import React from 'react';
import '../styles/BodyOverview.css';

interface BodyOverviewProps {
  onBack: () => void;
}

const BodyOverview: React.FC<BodyOverviewProps> = ({ onBack }) => {
  const healthSystems = [
    {
      id: 'digestive',
      name: '消化系统',
      status: 'warning',
      icon: '👍',
      issues: ['幽门螺旋杆菌阳性', '脂肪肝'],
      riskLevel: '重点监测'
    },
    {
      id: 'respiratory',
      name: '呼吸系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'nervous',
      name: '神经系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'circulatory',
      name: '循环系统',
      status: 'caution',
      icon: '👍',
      issues: ['高血压风险提醒'],
      riskLevel: '常规预警'
    },
    {
      id: 'endocrine',
      name: '内分泌系统',
      status: 'caution',
      icon: '👍',
      issues: ['2型糖尿病风险预警'],
      riskLevel: '常规预警'
    },
    {
      id: 'motor',
      name: '运动系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'urinary',
      name: '泌尿系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'reproductive',
      name: '生殖系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    },
    {
      id: 'immune',
      name: '免疫系统',
      status: 'normal',
      icon: '👍',
      issues: [],
      riskLevel: '维护保持'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'normal': return '#22c55e'; // 绿色
      case 'caution': return '#eab308'; // 黄色
      case 'warning': return '#f97316'; // 橙色
      case 'danger': return '#ef4444'; // 红色
      default: return '#22c55e';
    }
  };

  const getStatusBgColor = (status: string) => {
    switch (status) {
      case 'normal': return 'rgba(34, 197, 94, 0.1)'; // 浅绿色背景
      case 'caution': return 'rgba(234, 179, 8, 0.1)'; // 浅黄色背景
      case 'warning': return 'rgba(249, 115, 22, 0.1)'; // 浅橙色背景
      case 'danger': return 'rgba(239, 68, 68, 0.1)'; // 浅红色背景
      default: return 'rgba(34, 197, 94, 0.1)';
    }
  };

  const getRiskLevelColor = (status: string) => {
    switch (status) {
      case 'normal': return '#16a34a'; // 深绿色
      case 'caution': return '#ca8a04'; // 深黄色
      case 'warning': return '#ea580c'; // 深橙色
      case 'danger': return '#dc2626'; // 深红色
      default: return '#16a34a';
    }
  };

  return (
    <div className="body-overview-container">
      <div className="body-overview-content">
        {/* 顶部导航 */}
        <div className="body-nav">
          <button className="back-button" onClick={onBack}>
            <span className="back-icon">←</span>
            返回
          </button>
          <h2 className="body-title">身体概览</h2>
        </div>

        {/* 九大系统标题 */}
        <div className="systems-header">
          <div className="systems-title">九大系统</div>
        </div>

        {/* 九宫格系统展示 */}
        <div className="nine-grid-container">
          {healthSystems.map((system) => (
            <div 
              key={system.id} 
              className={`system-card ${system.status}`}
              style={{ backgroundColor: getStatusBgColor(system.status) }}
            >
              <div className="system-header">
                <h3 className="system-name">{system.name}</h3>
                <div 
                  className="status-icon"
                  style={{ color: getStatusColor(system.status) }}
                >
                  {system.status === 'normal' ? '👍' : system.status === 'caution' ? '⚠️' : system.status === 'warning' ? '🔶' : '🚨'}
                </div>
              </div>
              
              <div className="system-content">
                {system.issues.length > 0 ? (
                  <ul className="issue-list">
                    {system.issues.map((issue, index) => (
                      <li key={index} className="issue-item">• {issue}</li>
                    ))}
                  </ul>
                ) : (
                  <div className="normal-status">
                    <div 
                      className="thumbs-up"
                      style={{ color: getStatusColor(system.status) }}
                    >
                      👍
                    </div>
                  </div>
                )}
              </div>
              
              <div 
                className="risk-level-tag"
                style={{ 
                  backgroundColor: getStatusColor(system.status),
                  color: 'white'
                }}
              >
                {system.riskLevel}
              </div>
            </div>
          ))}
        </div>

        {/* 状态说明图例 */}
        <div className="legend-container">
          <div className="legend-item">
            <div className="legend-color danger"></div>
            <span className="legend-text">立即就医</span>
          </div>
          <div className="legend-item">
            <div className="legend-color warning"></div>
            <span className="legend-text">重点监测</span>
          </div>
          <div className="legend-item">
            <div className="legend-color caution"></div>
            <span className="legend-text">常规预警</span>
          </div>
          <div className="legend-item">
            <div className="legend-color normal"></div>
            <span className="legend-text">维护保持</span>
          </div>
        </div>


      </div>
    </div>
  );
};

export default BodyOverview; 